import Swiper from 'swiper/dist/js/swiper';

class BrixHeroSlideshow {
  static init(...parameters) {
    return new BrixHeroSlideshow(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.slideshow = block.querySelector('.slideshow');
    this.pagination = block.querySelector('.pagination');
    this.nextSlideButton = block.querySelector('.next-slide');
    this.prevSlideButton = block.querySelector('.prev-slide');

    const enableAutoplay = this.slideshow.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.slideshow.dataset.autoplayDelay, 10) * 1000;

    this.swiper = new Swiper(this.slideshow, {
      centeredSlides: true,
      autoplay: enableAutoplay ? { delay: autoplayDelay } : false,
      loop: true,
      navigation: {
        nextEl: this.nextSlideButton,
        prevEl: this.prevSlideButton,
      },
      pagination: {
        el: this.pagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'div',
        bulletClass: 'pagination-bullet',
        bulletActiveClass: '-active',
      },
      slideClass: 'brix-block',
      slidesPerView: 1,
      wrapperClass: 'slides',
    });

    window.addEventListener('resize', () => {
      // Render on resize to update swiper
      this.swiper.update();
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero-slideshow', BrixHeroSlideshow.init);
}
